
import React from 'react';
import Hero from '../components/enterprise/Hero';
import Solutions from '../components/enterprise/Solutions';
import Why from '../components/enterprise/Why';
import Features from '../components/enterprise/features';
import Cta from '../components/enterprise/Cta';
import Faq from '../components/enterprise/Faq';
import { Helmet } from 'react-helmet';

const EnterpriseOffering = () => {
    return (
        <div className="bg-black text-white min-h-screen">
            <Helmet>
                <title>Enterprise AI Solutions & Automation Consulting | Frost & Grey</title>

                <meta
                    name="description"
                    content="Frost & Grey delivers custom enterprise AI solutions including automation, AI strategy consulting, workflow optimization, custom assistants, and organization-wide AI capability development."
                />

                <link rel="canonical" href="https://frostandgrey.com/enterprise" />

                <meta property="og:title" content="Enterprise AI Solutions | Frost & Grey" />
                <meta property="og:description" content="AI strategy, workflow automation, and capability-building solutions for enterprises across Africa." />
                <meta property="og:url" content="https://frostandgrey.com/enterprise" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Hero />
            <Solutions />            
            <Why />
            <Features />
            <Cta />
            <Faq />
        </div>
    );
};

export default EnterpriseOffering;

